import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../models/question';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';

import './answer.css';
import { stripTags } from '../../utilities/string';

class Answer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.buildQuestion = this.buildQuestion.bind(this);
    }

    interpolateLabel(label) {
        if (!label || typeof label !== 'string') return label;

        const { client_name } = this.props;
        return label.replace(/{clientName}/g, client_name);
    }

    isMultiSelect(x) {
        if (typeof x !== 'object') return false;
        const values = Object.keys(x).map(k => x[k]);
        return !values.some(v => typeof v !== 'boolean');
    }

    formatMultiSelect(x) {
        return Object.keys(x)
            .filter(k => x[k])
            .join(', ');
    }

    formatAttribute(key, value) {
        if (key === 'moreInfo') return value;
        if (!value) return `${key}: ''`;
        if (this.isMultiSelect(value)) {
            return this.formatMultiSelect(value);
        }

        if (typeof value === 'object') return `${key}: ${JSON.stringify(value)}`;
        return `${key}: ${value}`;
    }

    formatAttributes(attributeString) {
        try {
            const attributes = JSON.parse(attributeString);
            return Object.keys(attributes)
                .map(k => this.formatAttribute(k, attributes[k]))
                .join(', ');
        } catch (err) {
            return attributeString;
        }
    }

    buildQuestion(question) {
        const answerValue = (question.answer && question.answer.answer) || '';
        const attributes = question.answer && JSON.stringify(question.answer.attributes) !== '{}' ? JSON.stringify(question.answer.attributes) : undefined;
        let field = null;

        const scoreValue = (question.answer && question.answer.score) || (question.scoring && question.scoring[answerValue]);
        const scoreColor = !scoreValue ? 'white ' : scoreValue < 0 ? 'red' : 'green';

        const label = this.interpolateLabel(stripTags(question.label));

        switch (question.type) {
            case 'y/n':
                let isYes = ['true', 'yes', 'y'].find(a => a === answerValue.toString().toLowerCase());
                let isNo = ['false', 'no', 'n'].find(a => a === answerValue.toString().toLowerCase());
                let yesNoAnswerLabel = isYes ? messages.yes : isNo ? messages.no : messages.noResponse;

                field = (
                    <div className="row">
                        <div className="col-xs-12 answer-item">
                            <div className="row">
                                <div className="col-xs-12 answer-item-question">{label}</div>
                                <div className={`answer-item-value-${scoreColor} col-xs-12`}>{<FormattedMessage {...yesNoAnswerLabel} />}</div>
                                {attributes && <div className="col-xs-12">{this.formatAttributes(attributes)}</div>}
                            </div>
                        </div>
                    </div>
                );
                break;

            case 'multi':
            case 'select':
            case 'date':
            case 'text':
                let generalAnswerLabel = answerValue || <FormattedMessage {...messages.noResponse} />;
                field = (
                    <div className="row">
                        <div className="col-xs-12 answer-item">
                            <div className="row">
                                <div className="col-xs-12 answer-item-question">{question.label}</div>
                                <div className={`answer-item-value-${scoreColor} col-xs-12`}>{generalAnswerLabel}</div>
                                {attributes && <div className="col-xs-12">{this.formatAttributes(attributes)}</div>}
                            </div>
                        </div>
                    </div>
                );
                break;

            default:
                break;
        }

        return field;
    }

    render() {
        const { definition } = this.props;
        if (!definition) {
            return null;
        }

        let question = new Question(definition);
        if (question.isFollowup) {
            return null;
        }

        return <div>{this.buildQuestion(question)}</div>;
    }
}

Answer.defaultProps = {
    definition: undefined
};

Answer.propTypes = {
    definition: PropTypes.object.isRequired
};

export default Answer;



// WEBPACK FOOTER //
// ./src/components/answer/index.jsx